export default "__VITE_ASSET__Dv7qjb02__"